import type { OmtAmsHelpArticleId } from "@/lib/omt-ams-help/articles";

/** Help article for the OMT/AMS dashboard header, based on the selected tab. */
export function getOmtAmsDashboardContextHelpArticleId(
  tab: string,
): OmtAmsHelpArticleId {
  switch (tab) {
    case "users":
      return "user-management";
    case "needs-attention":
      return "needs-attention";
    case "renewable":
    case "inactive":
      return "registrations";
    default:
      return "dashboard";
  }
}
